module.exports = __webpack_public_path__ + "img/icon_gg.09a035e0.png";